import { PermissionEnum } from '@ui/src';
import AccountsRoutes from '@accounts/routes';
import ClientsRoutes from '@clients/routes';
import {
  BankRoutes,
  FeesRoutes,
  TariffsRoutes,
  CardsRoutes,
  CurrenciesRoutes,
} from '@configuration/routes';
import ExchangeRoutes from '@exchange/routes';
import DashboardRoutes from '@dashboard/routes';
import AdministrationRoutes from '@administration/routes';
import MessagesRoutes from '@messaging/routes';
import ReportsRoutes from '@reports/routes';
import AmlKycRoutes from '@aml/routes';
import TransactionsRoutes from '@transactions/routes';

const permissionsTree = [
  {
    key: PermissionEnum.SECTION_DASHBOARD,
    url: DashboardRoutes.DASHBOARD,
  },
  {
    key: PermissionEnum.SECTION_ACCOUNTS,
    url: AccountsRoutes.ACCOUNTS,
    pages: [
      {
        key: PermissionEnum.ACCOUNTS_LIST,
        url: AccountsRoutes.ACCOUNTS,
      },
      {
        key: PermissionEnum.ACCOUNTS_STATEMENTS,
        url: AccountsRoutes.STATEMENTS_OF_ACCOUNTS,
      },
      {
        key: PermissionEnum.ACCOUNTS_CHART,
        url: AccountsRoutes.CHARTS_OF_ACCOUNTS,
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_CUSTOMERS,
    url: ClientsRoutes.CUSTOMERS,
    pages: [
      {
        key: PermissionEnum.INDIVIDUAL_CUSTOMERS_LIST,
        url: ClientsRoutes.CUSTOMERS_INDIVIDUAL,
      },
      {
        key: PermissionEnum.CORPORATE_CUSTOMERS_LIST,
        url: ClientsRoutes.CUSTOMERS_CORPORATE,
      },
      // {
      //   key: PermissionEnum.PAYMENT_INSTITUTIONS_CUSTOMERS_LIST,
      //   url: ClientsRoutes.CUSTOMERS_PAYMENT_INSTITUTION
      // },
      {
        key: PermissionEnum.MESSAGES_LIST,
        url: MessagesRoutes.MESSAGES,
      },
      {
        key: PermissionEnum.APPLICATIONS_CUSTOMERS_LIST,
        url: ClientsRoutes.CUSTOMERS_NEW_APPLICATION,
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_AML_KYC,
    pages: [
      {
        key: PermissionEnum.BLACKLISTS_LIST,
        url: AmlKycRoutes.BLACKLIST,
      },
      {
        key: PermissionEnum.AML_SETTINGS_LIST,
        url: AmlKycRoutes.RISK_LEVELS,
      },
      {
        key: PermissionEnum.AML_GEO_LIST,
        url: AmlKycRoutes.GEOGRAPHICAL,
      },
      {
        key: PermissionEnum.SETTINGS_TRANSACTIONS_VOLUMES_LIST,
        url: AmlKycRoutes.TRANSACTIONS_RISK,
      },
      {
        key: PermissionEnum.AML_MONITORING_RULES_LIST,
        url: AmlKycRoutes.TRANSACTION_MONITORING_RULES,
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_TRANSACTIONS,
    url: TransactionsRoutes.TRANSACTIONS,
    pages: [
      {
        key: PermissionEnum.TRANSACTIONS_IMPORT_LIST,
        url: TransactionsRoutes.IMPORT,
      },
      {
        key: PermissionEnum.TRANSACTIONS_EXPORT_LIST,
        url: TransactionsRoutes.EXPORT,
      },
      {
        key: PermissionEnum.TRANSACTIONS_INCOMING_LIST,
        url: TransactionsRoutes.INCOMING,
      },
      {
        key: PermissionEnum.TRANSACTIONS_OUTGOING_LIST,
        url: TransactionsRoutes.OUTGOING,
      },
      {
        key: PermissionEnum.TRANSACTIONS_INTERNAL_LIST,
        url: TransactionsRoutes.INTERNAL_TRANSACTION,
      },
      {
        key: PermissionEnum.TRANSACTIONS_EXCHANGE_LIST,
        url: TransactionsRoutes.EXCHANGE,
      },
      {
        key: PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_LIST,
        url: TransactionsRoutes.GENERAL_LEDGER,
      },
      {
        key: PermissionEnum.TRANSACTIONS_NOSTRO_LIST,
        url: TransactionsRoutes.NOSTRO_TRANSFER,
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_CARDS,
    url: CardsRoutes.CARDS,
  },
  {
    key: PermissionEnum.SECTION_REPORTS,
    url: ReportsRoutes.REPORTS,
    pages: [
      {
        key: PermissionEnum.REPORTS_BALANCE_SHEET_LIST,
        url: ReportsRoutes.REPORTS_BALANCE_SHEET,
      },
      {
        key: PermissionEnum.REPORTS_PROFIT_LOSS_LIST,
        url: ReportsRoutes.REPORTS_PROFIT_lOSS_SHEET,
      },
      {
        key: PermissionEnum.REPORTS_SAFEGUARDING_LIST,
        url: ReportsRoutes.REPORTS_SAFEGUARDING,
      },
      {
        key: PermissionEnum.REPORTS_CAPITAL_ADEQUACY_LIST,
        url: ReportsRoutes.REPORTS_CAPITAL_ADEQUACY,
      },
      {
        key: PermissionEnum.REPORTS_PSP_LIST,
        url: ReportsRoutes.REPORTS_BANK_AND_PSP,
      },
      {
        key: PermissionEnum.REPORTS_CURRENCY_POSITION_LIST,
        url: ReportsRoutes.REPORTS_CURRENCY_POSITION,
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_PSP,
    url: BankRoutes.BANK_AND_PSP,
  },
  {
    key: PermissionEnum.SECTION_EXCHANGE_SETTINGS,
    pages: [
      {
        key: PermissionEnum.SETTINGS_CURRENCIES_LIST,
        url: CurrenciesRoutes.CURRENCIES,
      },
      {
        key: PermissionEnum.SETTINGS_EXCHANGE_RATES_LIST,
        url: ExchangeRoutes.RATES,
      },
      {
        key: PermissionEnum.SETTINGS_EXCHANGE_MARGINS_LIST,
        url: ExchangeRoutes.MARGINS,
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_FEE_TARIFFS,
    pages: [
      {
        key: PermissionEnum.FEES_TYPES_LIST,
        url: FeesRoutes.FEES,
      },
      {
        key: PermissionEnum.TARIFFS_LIST,
        url: TariffsRoutes.TARIFFS,
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_ADMINISTRATION,
    url: AdministrationRoutes.ADMINISTRATION,
    pages: [
      {
        key: PermissionEnum.USERS_LIST,
        url: AdministrationRoutes.USER_LIST,
      },
      {
        key: PermissionEnum.USERS_ROLES_LIST,
        url: AdministrationRoutes.USER_ROLES,
      },
      {
        key: PermissionEnum.SETTINGS_SYSTEM_LIST,
        url: AdministrationRoutes.SETTINGS,
      },
    ],
  },
];

export default permissionsTree;
